module.exports = __webpack_public_path__ + "static/media/QRCode.c8a6cdcd.png";